export const LISTINGS_PAGE_TAGS = [
  'getListingProperties',
  'getListingPropertyUnits',
  'getListingUnitsList',
  'getListingOptions',
] as const;

export const MULTIPLEX_MUTATION_INVALIDATES = [
  'getProperties',
  'getPropertyTableUnits',
  'getMultiplexUnits',
  ...LISTINGS_PAGE_TAGS,
] as const;

export const CURRENT_USER_TAG = 'currentUser';

export const FEATURES_BETA_TAG = 'featuresBeta';

export const PORTFOLIO_DASHBOARD_TAG = 'portfolioDashboard';

export const CREATE_LISTING_MUTATION_INVALIDATES = [
  PORTFOLIO_DASHBOARD_TAG,
  'getProperties',
  'getMultiplexUnits',
  'getPropertyTableUnits',
  'zramOptions',
  ...LISTINGS_PAGE_TAGS,
] as const;
